import { render, staticRenderFns } from "./PdpAttributes.vue?vue&type=template&id=03835572&scoped=true"
import script from "./PdpAttributes.vue?vue&type=script&lang=js"
export * from "./PdpAttributes.vue?vue&type=script&lang=js"
import style0 from "./PdpAttributes.vue?vue&type=style&index=0&id=03835572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03835572",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fpdp-attributes%2FPdpAttributes.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports